angular.module('jv.apply-form-preview.service', [])
.service('ApplyFormPreviewService', [
    '$http', '$q', 'TextUtil',
    function($http, $q, TextUtil) {
        var customFormUrl = jvUrls.jhire + '/action/customForm'
        this.getForm = function(id) {
            var url = [customFormUrl, id, 'fields'].join('/');
            return $http.get(url).then(function(response) {
                if (!response || !response.data || typeof response.data.viewFields === 'undefined') {
                    return $q.reject();
                }
                if (response.data.viewFields) {
                    return TextUtil.getParsedCustomFieldHtmlProperties(response.data.viewFields.sort(function(a, b) {
                        return a.position - b.position;
                    }));
                }
                return [];
            });
        };
    }
]);